import { render, staticRenderFns } from "./CaseRepeatedFeedback.vue?vue&type=template&id=24af9c52&"
import script from "./CaseRepeatedFeedback.vue?vue&type=script&lang=js&"
export * from "./CaseRepeatedFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports